// Store user's answers to questions
var userAnswers = [
  {
    question: 'Is this for an On-Premises or Cloud Environment?',
    answer: ''
  },
  {
    question: 'What version year do you need?',
    answer: ''
  },
  {
    question: 'What edition do you need?',
    answer: ''
  },
  {
    question: 'How many SQL instances do you need to license?',
    answer: ''
  },
  {
    question: 'How is the database queried?',
    answer: ''
  },
  {
    question: 'Are you running a public web-facing application?',
    answer: ''
  },
  {
    question: 'How many connect directly to SQL?',
    customObj: ''
  },
  {
    question: 'How many connect to the application?',
    customObj: ''
  },
  {
    question: 'Is your SQL instance deployed on Host or VM?',
    answer: ''
  },
  {
    question: 'How many physical cores does your host have?',
    answer: ''
  },
  {
    question: 'How many cores does the VM have allocated?',
    answer: ''
  }
]
    
// Store all calculator questions
var questionTree = [
  {
    question: 'Is this for an On-Premises or Cloud Environment?',
    answers: [
      'On-Premises',
      'Cloud'
    ],
    followUpQuestions: {
      'On-Premises': 'What version year do you need?',
      'Cloud': 'What version year do you need?'
    },
    percentComplete: '0%'
  },
  {
    question: 'What version year do you need?',
    answers: [
      '2022',
      '2019',
      '2017',
      '2016'
    ],
    followUpQuestions: {
      '2022': 'What edition do you need?',
      '2019': 'What edition do you need?',
      '2017': 'What edition do you need?',
      '2016': 'What edition do you need?'
    },
    percentComplete: '12%'
  },
  {
    question: 'What edition do you need?',
    answers: [
      'Standard',
      'Enterprise'
    ],
    followUpQuestions: {
      'Standard': 'How many SQL instances do you need to license?',
      'Enterprise': 'How many SQL instances do you need to license?'
    },
    percentComplete: '24%'
  },
  {
    question: 'How many SQL instances do you need to license?',
    answers: [
      'One',
      'Two or more'
    ],
    followUpQuestions: {
      'One': 'How is the database queried?',
      'Two or more': 'END'
    },
    previousAnswerBasedDependency: {
      question: 'Is this for an On-Premises or Cloud Environment?',
      cloud: 'How many cores does the VM have allocated?',
      onPremises: 'How is the database queried?'
    },
    customAnswersBasedDependency: {
      onPremStandard: 'How is the database queried?',
      onPremEnterprise: 'Is your SQL instance deployed on Host or VM?',
      cloudStandard: 'How is the database queried?',
      cloudEnterprise: 'How many cores does the VM have allocated?'
    },
    percentComplete: '36%'
  },
  {
    question: 'How is the database queried?',
    answers: [
      'Directly to SQL',
      'Through an application'
    ],
    followUpQuestions: {
      'Directly to SQL': 'How many connect directly to SQL?',
      'Through an application': 'Are you running a public web-facing application?'
    },
    percentComplete: '42%'
  },
  {
    question: 'Are you running a public web-facing application?',
    answers: [
      'Yes',
      'No'
    ],
    followUpQuestions: {
      'Yes': 'Is your SQL instance deployed on Host or VM?',
      'No': 'How many connect to the application?'
    },
    percentComplete: '52%'
  },
  {
    question: 'How many connect directly to SQL?',
    answers: [
      'custom-input-connections-count'
    ],
    followUpQuestions: {
      'custom-input-connections-count': 'Is your SQL instance deployed on Host or VM?'
    },
    minimumBasedDependency: {
      minimumCount: 25,
      minimumMet: 'Is your SQL instance deployed on Host or VM?',
      minimumNotMet: 'END'
    },
    customAnswersBasedDependency: {
      onPremStandard: 'Is your SQL instance deployed on Host or VM?',
      onPremEnterprise: 'Is your SQL instance deployed on Host or VM?',
      cloudStandard: 'How many cores does the VM have allocated?',
      cloudEnterprise: 'How many cores does the VM have allocated?'
    },
    minimumInput: '1',
    maximumInput: '1000',
    inputRequirements: [
      'Select either <b>Users</b> or <b>Devices</b>',
      'Enter the total amount of connections',
      'Minimum of 1 connection required'
    ],
    percentComplete: '75%'
  },
  {
    question: 'How many connect to the application?',
    answers: [
      'custom-input-connections-count'
    ],
    followUpQuestions: {
      'custom-input-connections-count': 'Is your SQL instance deployed on Host or VM?'
    },
    minimumBasedDependency: {
      minimumCount: 25,
      minimumMet: 'Is your SQL instance deployed on Host or VM?',
      minimumNotMet: 'END'
    },
    customAnswersBasedDependency: {
      onPremStandard: 'Is your SQL instance deployed on Host or VM?',
      onPremEnterprise: 'Is your SQL instance deployed on Host or VM?',
      cloudStandard: 'How many cores does the VM have allocated?',
      cloudEnterprise: 'How many cores does the VM have allocated?'
    },
    minimumInput: '1',
    maximumInput: '1000',
    inputRequirements: [
      'Select either <b>Users</b> or <b>Devices</b>',
      'Enter the total amount of connections',
      'Minimum of 1 connection required'
    ],
    percentComplete: '75%'
  },
  {
    question: 'Is your SQL instance deployed on Host or VM?',
    answers: [
      'Host',
      'VM'
    ],
    followUpQuestions: {
      'Host': 'How many physical cores does your host have?',
      'VM': 'How many cores does the VM have allocated?'
    },
    percentComplete: '87%'
  },
  {
    question: 'How many physical cores does your host have?',
    answers: [
      'standard-input',
    ],
    followUpQuestions: {
      'standard-input': 'END'
    },
    minimumInput: '4',
    maximumInput: '1000',
    inputRequirements: [
      'Minimum of 4 cores',
      'The total must be an even number'
    ],
    evenInput: 'true',
    percentComplete: '97%'
  },
  {
    question: 'How many cores does the VM have allocated?',
    answers: [
      'standard-input',
    ],
    followUpQuestions: {
      'standard-input': 'END'
    },
    minimumInput: '4',
    maximumInput: '1000',
    inputRequirements: [
      'Minimum of 4 cores',
      'The total must be an even number'
    ],
    evenInput: 'true',
    percentComplete: '97%'
  },
  {
    question: 'END',
    answers: [],
    followUpQuestions: {},
    percentComplete: '100%'
  }
]
    
// Track the user's pathway to navigate backwards if needed
var previousQuestionPath = [];
  
// Default Calendly link
var calendlySqlLink = 'https://calendly.com/trusted-tech-team-licensing-engineer/sql';

// Store data to send to sales channel when 'Request a Quote' form submitted
var calcResults = 'Hi Trusted Tech Team,\r\n\r\nCould you please send me a personalized quote based on my SQL Server Calculator results?\r\n\r\nThank you!\r\n\r\nMy SQL Server Calculator Results:\r\n\r\n';
    
// Display the answers or table for a question
function displayAnswers(questionObject) {

  // Store the HTML for the possible answers that will be displayed for each question
  var questionInputsHTML = '';
  
  // Get all the possible answers for the current question and iterate through them all
  questionObject.answers.forEach((answer, index, arr) => {
    if(answer != undefined && answer != 'standard-input' && answer != 'custom-input-connections-count'){
      questionInputsHTML += '<button class="raise collection-button calc-button m-auto text-start" onclick="showNextQuestion(this.textContent, this)"><i class="fa-regular fa-circle regular"></i><i class="fa-solid fa-circle solid" style="display: none;"></i>' + answer + '</button>';
      if (arr.length - 1 == index) {
        questionInputsHTML = '<div class="d-flex flex-wrap gap-3 justify-content-start justify-content-lg-center">' + questionInputsHTML + '</div>';
      } 
    } else if (answer == 'standard-input') {
      questionInputsHTML += '<div class="position-relative text-center"><i class="fa-solid fa-circle-exclamation" ' + (questionObject.minimumInput && ('data-tippy-content="Minimum of ' + parseInt(questionObject.minimumInput) + ' required"')) + ' style="display: none; position: absolute; right: 20px; top: 38%; color: red;"></i><i class="fa-solid fa-circle-check" style="display: none; position: absolute; right: 20px; top: 38%; color: green;"></i><input id="standard-input"' + (questionObject.minimumInput ? (' min="' + parseInt(questionObject.minimumInput) + '"') : ' ') + (questionObject.maximumInput ? (' max="' + parseInt(questionObject.maximumInput) + '"') : ' ') + (questionObject.emptyInputAccepted ? (' data-emptyinputaccepted="true" ') : ' ');
      questionInputsHTML += 'data-toggle="collapse" data-target="#epSubNew" data-eveninput="' + (questionObject.evenInput == 'true') + '" oninput="validateValue(this.value, this)" type="text" style="transition: none; text-align: center; margin: 0 0 10px;" placeholder="Enter answer here" /></div><p style="color: red; display: none;" id="min-input-error"><i class="fa-solid fa-circle-exclamation" style="margin-right: 5px;"></i>Minimum 5 required</p><button style="transition: transform 0.25s;" class="raise collection-button calc-button m-auto text-center" onclick="showNextQuestion('+"'"+answer+"'"+')"';
      questionInputsHTML += (parseInt(questionObject.minimumInput) > 0 && 'disabled') + '>Continue <i class="fa-solid fa-arrow-right"></i></button>';
    } else if (answer == 'custom-input-connections-count') {
      questionInputsHTML += '<div class="d-flex justify-content-start justify-content-lg-center gap-3" id="toggle-container" style="margin: 0;"><div id="toggle-btn-container" class="d-flex justify-content-between"><button class="collection-button calc-button m-0 me-3 selected" id="users-button" style="padding: 1em 1.4em; border: 2px solid var(--main-text-color); width: 49%; text-align: start;" onclick="toggle(&#39;users&#39;)"><i class="fa-regular fa-circle regular" style="display: none;"></i><i class="fa-solid fa-circle solid" style="display: inline;"></i>Users</button><button class="collection-button calc-button m-0" id="devices-button" style="padding: 1em 1.4em; border: 2px solid var(--main-text-color); width: 49%; text-align: start;" onclick="toggle(&#39;devices&#39;)"><i class="fa-regular fa-circle regular"></i><i class="fa-solid fa-circle solid" style="display: none;"></i>Devices</button></div></div>';
      questionInputsHTML += '<div class="position-relative text-center my-3"><i class="fa-solid fa-circle-exclamation" ' + (questionObject.minimumInput && ('data-tippy-content="Minimum of ' + parseInt(questionObject.minimumInput) + ' required"')) + ' style="display: none; position: absolute; right: 20px; top: 38%; color: red;"></i><i class="fa-solid fa-circle-check" style="display: none; position: absolute; right: 20px; top: 38%; color: green;"></i><input id="standard-input"' + (questionObject.minimumInput ? (' min="' + parseInt(questionObject.minimumInput) + '"') : ' ') + (questionObject.maximumInput ? (' max="' + parseInt(questionObject.maximumInput) + '"') : ' ') + (questionObject.emptyInputAccepted ? (' data-emptyinputaccepted="true" ') : ' ');
      questionInputsHTML += 'data-toggle="collapse" data-target="#epSubNew" data-eveninput="' + (questionObject.evenInput == 'true') + '" oninput="validateValue(this.value, this)" type="text" style="transition: none; text-align: center; margin: 0;" placeholder="Enter answer here" /></div><p style="color: red; display: none;" id="min-input-error"><i class="fa-solid fa-circle-exclamation" style="margin-right: 5px;"></i>Minimum 5 required</p><button style="transition: transform 0.25s;" class="raise collection-button calc-button m-auto text-center" onclick="showNextQuestion('+"'"+answer+"'"+')"';
      questionInputsHTML += (parseInt(questionObject.minimumInput) > 0 && 'disabled') + '>Continue <i class="fa-solid fa-arrow-right"></i></button>';      }
  });

  
  // Display input requirements for the current question if applicable 
  if (questionObject.inputRequirements) {
    var inputRequirementsHTML = '<ul class="text-start">';
    questionObject.inputRequirements.forEach((item) => {
      inputRequirementsHTML += '<li>' + item + '</li>';
    });
    inputRequirementsHTML += '</ul>';
    $('input-requirements').show();
    document.getElementById('input-requirements').innerHTML = inputRequirementsHTML;
  } else {
    $('input-requirements').hide();
    document.getElementById('input-requirements').innerHTML = '';
  }
  
  // Display everything
  document.getElementById('sql-question-answers').innerHTML = questionInputsHTML;
  document.querySelector('.progress-bar').style = "width: " + questionObject.percentComplete + "; background-color: var(--border-color);";
  document.querySelector('#percent-complete').innerHTML = questionObject.percentComplete + " COMPLETE";
}

// Toggle for the USER/DEVICE connections count
function toggle(selectedOption) {
  var usersButton = document.getElementById('users-button');
  var devicesButton = document.getElementById('devices-button');

  if (selectedOption === 'users') {
    usersButton.classList.add('selected');
    devicesButton.classList.remove('selected');

    var regularUsersIcon = usersButton.querySelector('.regular');
    var solidUsersIcon = usersButton.querySelector('.solid');
    regularUsersIcon.style.display = "none";
    solidUsersIcon.style.display = "inline";

    var regularDevicesIcon = devicesButton.querySelector('.regular');
    var solidDevicesIcon = devicesButton.querySelector('.solid');
    regularDevicesIcon.style.display = "inline";
    solidDevicesIcon.style.display = "none";

  } else if (selectedOption === 'devices') {
    usersButton.classList.remove('selected');
    devicesButton.classList.add('selected');

    var regularUsersIcon = usersButton.querySelector('.regular');
    var solidUsersIcon = usersButton.querySelector('.solid');
    regularUsersIcon.style.display = "inline";
    solidUsersIcon.style.display = "none";

    var regularDevicesIcon = devicesButton.querySelector('.regular');
    var solidDevicesIcon = devicesButton.querySelector('.solid');
    regularDevicesIcon.style.display = "none";
    solidDevicesIcon.style.display = "inline";

  }
}
  
// Toggle the view of 'Your Answers'
function toggleYourAnswers(toggle) {
  if (toggle == 'show') {
    $('#your-answers').height('min-content');
    $('#your-answers-cover').hide();
  } else if (toggle == 'hide') {
    $('#your-answers').height('225px');
    $('#your-answers-cover').show();
  }
}
  
// Show the previous question when user navigates backwards
function showPreviousQuestion() {

  // Find the previous question and display it
  let currentQuestionObject = questionTree.find(function(obj) {
    return obj.question == previousQuestionPath[previousQuestionPath.length - 1];
  });
  document.getElementById('sql-question-text').innerHTML = currentQuestionObject.question;
  
  // Find the previous question in userAnswers and set to empty
  userAnswers.find(function(obj) {
    if(obj.question == currentQuestionObject.question){
      if(obj.answer){
        obj.answer = '';
      } else if (obj.customObj){
        obj.customObj = '';
      } 
    }
  });
  
  setCalendlyOnClick('help', currentQuestionObject.question);

  displayAnswers(currentQuestionObject);
  previousQuestionPath.pop();

  // If first question then hide 'previous' button
  if (previousQuestionPath.length > 0){
    $('.btn-previous').show();
  } else {
    $('.btn-previous').hide();
  }

  setTooltips();
}

// Validate the inputs on submit
function validateInputs(answer) {
  let noContinue = false;
  if (answer == "standard-input") {
    let minInputError = false;
    let input = document.querySelector('#standard-input');
    if (input.max && ((parseInt(input.value)) > (parseInt(input.max)))) {
      let answer = "More than " + input.max;
      setAnswer(answer);
      showResults("calc-error");
      return false;
    }
    if ((parseInt(input.min) > 0 && parseInt(input.value) < parseInt(input.min)) && (input.dataset.emptyinputaccepted == 'true' ? (parseInt(input.value) != '0' || parseInt(input.value) != '') : true )){
      input.style.border = '1px solid red';
      input.previousElementSibling.style.display = 'inline';
      minInputError = true;
      noContinue = true;
    } else if (parseInt(input.min) == 0 && input.value == '') {
      input.value = 0;
      input.setAttribute('value', 0);
    }
    minInputError ? $('#min-input-error').show() : $('#min-input-error').hide();
    if (noContinue){ return false; }
  } else if (answer == "custom-input-connections-count") {
    let input = document.querySelector('#standard-input');
    if (input.max && ((parseInt(input.value)) > (parseInt(input.max)))) {
      let answer = "More than " + input.max;
      setAnswer(answer);
      showResults("calc-error");
      return false;
    }
  }
}
  
// Store the user's submitted input
function setAnswer(answer) {
  var answeredQuestion = userAnswers.find(function(obj) {
    return obj.question == document.getElementById('sql-question-text').innerHTML;
  });
  if(answer == 'standard-input') {
    answeredQuestion.answer = document.getElementById('standard-input').value;
  } else if (answer == 'custom-input-connections-count') {
    customInputObj = {
      type: '',
      total: ''
    };
    if (document.getElementById('users-button').classList.contains('selected')) {
      customInputObj.type = 'user';
    } else {
      customInputObj.type = 'device';
    }
    customInputObj.total = document.getElementById('standard-input').value;
    answeredQuestion.customObj = customInputObj;
  } else {
    answeredQuestion.answer = "'" + answer + "'";
  }
}

// Returns the user's answer of a given question
function getAnswer(question) {
  var answeredQuestion = userAnswers.find(function(obj) {
    return obj.question == question;
  });
  if (answeredQuestion.customObj && answeredQuestion.customObj.total) {
    return answeredQuestion.customObj.total;
  } else {
    return answeredQuestion.answer
  }
}
  
// Show the next question based on the user's input
function showNextQuestion(answer, element) {
  if (validateInputs(answer) == false) { return; }

  if (element){
    element.classList.add('selected');
  
    var selectedAnswer = document.querySelector('.calc-button.selected');
    var regularIcon = selectedAnswer.querySelector('.regular');
    var solidIcon = selectedAnswer.querySelector('.solid');
  
    regularIcon.style.display = "none";
    solidIcon.style.display = "inline";
  }
  setTimeout(function() {

    $('.current-question').hide();

    setAnswer(answer);
    
    var currentQuestionObject = questionTree.find(function(obj) {
      return obj.question == document.getElementById('sql-question-text').innerHTML;
    });
    
    previousQuestionPath.push(currentQuestionObject.question);
    
    if (previousQuestionPath.length > 0){
      $('.btn-previous').show();
    } else {
      $('.btn-previous').hide();
    }

    if (currentQuestionObject.minimumBasedDependency && currentQuestionObject.followUpQuestions[answer] != "END"){
      if (parseInt(getAnswer(currentQuestionObject.question)) >= currentQuestionObject.minimumBasedDependency.minimumCount) {
        if (currentQuestionObject.customAnswersBasedDependency){
          var environmentType = getAnswer("Is this for an On-Premises or Cloud Environment?");
          var edition = getAnswer("What edition do you need?");
          if (edition == "'Standard'" && environmentType == "'On-Premises'") {
            var nextQuestion = currentQuestionObject.customAnswersBasedDependency.onPremStandard;
          } else if (edition == "'Standard'" && environmentType == "'Cloud'") {
            var nextQuestion = currentQuestionObject.customAnswersBasedDependency.cloudStandard;
          } else if (edition == "'Enterprise'" && environmentType == "'On-Premises'") {
            var nextQuestion = currentQuestionObject.customAnswersBasedDependency.onPremEnterprise;
          } else if (edition == "'Enterprise'" && environmentType == "'Cloud'") {
            var nextQuestion = currentQuestionObject.customAnswersBasedDependency.cloudEnterprise;
          }
        } else {
          var nextQuestion = currentQuestionObject.minimumBasedDependency.minimumMet;
        }
      } else {
        var nextQuestion = currentQuestionObject.minimumBasedDependency.minimumNotMet;
      }
    } else if (currentQuestionObject.customAnswersBasedDependency && currentQuestionObject.followUpQuestions[answer] != "END") {
      var environmentType = getAnswer("Is this for an On-Premises or Cloud Environment?");
      var edition = getAnswer("What edition do you need?");
      if (edition == "'Standard'") {
        var nextQuestion = currentQuestionObject.customAnswersBasedDependency.onPremStandard;
      } else if (edition == "'Enterprise'" && environmentType == "'On-Premises'") {
        var nextQuestion = currentQuestionObject.customAnswersBasedDependency.onPremEnterprise;
      } else if (edition == "'Enterprise'" && environmentType == "'Cloud'") {
        var nextQuestion = currentQuestionObject.customAnswersBasedDependency.cloudEnterprise;
      }
    } else {
      var nextQuestion = currentQuestionObject.followUpQuestions[answer];
    }
    
    document.getElementById('sql-question-text').innerHTML = nextQuestion;
    setCalendlyOnClick('help', nextQuestion);
    
    var nextQuestionObject = questionTree.find(function(obj) {
        return obj.question == nextQuestion;
    });
    if(nextQuestionObject.question == 'END'){
      showResults();
    }
    
    displayAnswers(nextQuestionObject);

    $('.current-question').show();
    
    setTooltips();
  }, 100);
}
  
// Validate input value on-change
function validateValue(value, e) {
  if (/^\d+$/.test(value)){
    if (value.split('')[0] == '0') {
      e.value = 0;
      e.setAttribute("value", 0);
    }
    else if ((e.placeholder == '# of Cores' || parseInt(e.min) > 0) && value == 0) {
      e.value = '';
      e.setAttribute("value", '');
      return;
    } else {
      e.setAttribute("value",value);
    }
    if (e.id == 'standard-input') {
      if (e.min && (e.dataset.eveninput == 'true')){
        if (((BigInt(e.value) >= BigInt(e.min)) && (BigInt(e.value) % BigInt(2) == BigInt(0))) || ((e.dataset.emptyinputaccepted == 'true') ? (parseInt(e.value) == 0 || parseInt(e.value) == '') : false)){
          e.previousElementSibling.style.display = 'none';
          e.style.border = "2px solid var(--ttt-green)";
          $('.fa-circle-exclamation').hide();
          $('.fa-circle-check').show();
          $('.collection-button').prop("disabled", false);

        } else {
          e.style.border = "2px solid red";
          $('.fa-circle-check').hide();
          $('.fa-circle-exclamation').show();
          $('.collection-button').prop("disabled", true);
        }
      } else if (e.min){
        if ((parseInt(e.value) >= parseInt(e.min)) || ((e.dataset.emptyinputaccepted == 'true') ? (parseInt(e.value) == 0 || parseInt(e.value) == '') : false)){
          e.previousElementSibling.style.display = 'none';
          e.style.border = "2px solid var(--ttt-green)";
          $('.fa-circle-exclamation').hide();
          $('.fa-circle-check').show();
          $('.collection-button').prop("disabled", false);
        } else {
          e.style.border = "2px solid red";
          $('.fa-circle-check').hide();
          $('.fa-circle-exclamation').show();
          $('.collection-button').prop("disabled", true);
        }
      } else if (value != ''){
        e.previousElementSibling.style.display = 'none';
        e.style.border = "2px solid var(--ttt-green)";
        $('.fa-circle-exclamation').hide();
        $('.fa-circle-check').show();
        $('.collection-button').prop("disabled", false);
      } else {
        e.style.border = "2px solid var(--main-text-color)";
        $('.fa-circle-check').hide();
        $('.fa-circle-exclamation').hide(); 
        $('.collection-button').prop("disabled", true);
      }
    } else {
      if (e.placeholder == '# of Cores' && (parseInt(value) % 2 == 1 || parseInt(value) < 2 || e.value < 2)) {
          e.parentElement.style.border = "1px solid red";
          e.nextElementSibling.style.display = 'none';
          e.previousElementSibling.style.display = 'inline';
      } else {
        if (e.placeholder == '# of Cores' || e.placeholder == '# of VMs') {
          e.parentElement.style.border = "1px solid var(--ttt-green)"
          e.previousElementSibling.style.display = 'none';
          e.nextElementSibling.style.display = 'inline';
        } else {
          e.previousElementSibling.style.display = 'none';
          $('.fa-circle-exclamation').hide();
          $('.fa-circle-check').show();
          e.parentElement.style.border = "1px solid var(--main-text-color)"; 
        }
      }
    }
  } else {
    if (e.id == 'standard-input' && value == ''){
      e.style.border = "2px solid var(--main-text-color)";
      e.style.color = "var(--main-text-color)";
      $('.fa-circle-check').hide();
      $('.fa-circle-exclamation').hide();
      
      (parseInt(e.min) == 0) ? $('.collection-button').prop("disabled", false) : $('.collection-button').prop("disabled", true);
      return;
    }
    let inputString = convertToNumeric(value);
    e.value = inputString;
    e.setAttribute("value", inputString);
    if (e.placeholder == '# of Cores' || e.placeholder == '# of VMs') {
      e.parentElement.style.border = "1px solid var(--main-text-color)";
      e.style.color = "var(--main-text-color)";
      e.previousElementSibling.style.display = 'none';
      e.nextElementSibling.style.display = 'none';
    }
    return;
  }
}
  
// Remove any non-numerical values from string
function convertToNumeric(str) {
  let numericString = str.split('');
  numericString.forEach((char, i) => {
    if (char != '0' && char != '1' && char != '2' && char != '3' && char != '4' && char != '5' && char != '6' && char != '7' && char != '8' && char != '9') {
      numericString[i] = '';
    }
  });
  return numericString.join('');
}

// Display loading screen for 3 seconds
function displayLoadingIcon(){
  $('#loading-screen').show();
  setTimeout(() => {
    $('#loading-screen').hide();
  }, 3000);
}
  
// Set question and answers to be displayed on the results page
function setResponses() {
  var visibleAnswers = '';
  userAnswers.forEach((question) => {
    if(question.answer){
      if(question.answer != ''){
        visibleAnswers += '<p style="margin-bottom: 0; color: var(--main-text-color);">' + question.question + '</p>';
        var displayedAnswer;
        if (question.answer.includes("'")){
          displayedAnswer = question.answer.split("'")[1];
        } else {
          displayedAnswer = question.answer;
        }
        visibleAnswers += '<p style="color: var(--ttt-green);">' + displayedAnswer + '</p>';
      }
    }
    if(question.customObj){
      if(question.customObj != ''){
        visibleAnswers += '<p style="margin-bottom: 0; color: var(--main-text-color);">' + question.question + '</p>';
        var displayedAnswer;
        displayedAnswer = question.customObj.total + ' ' + question.customObj.type + '(s)';
        visibleAnswers += '<p style="color: var(--ttt-green);">' + displayedAnswer + '</p>';
      }
    }
  });
  document.getElementById("sql-responses").innerHTML = visibleAnswers;
}

// Calculate licensing info to be displayed on the results page
function calculateLicensing() {
  var environment = getAnswer("Is this for an On-Premises or Cloud Environment?").split("'")[1];
  var year = getAnswer("What version year do you need?").split("'")[1];
  var edition = getAnswer("What edition do you need?").split("'")[1];
  var runsPublicApp = getAnswer("Are you running a public web-facing application?").split("'")[1] == "Yes" ? true : false;

  var numberOfConnections = 0;
  var numCores = 0;

  var serverTableResults = '';
  var coreTableResults = '';
  var licenseArray = [];

  var recommendedModel;
  var ovl = false;

  if (environment == "On-Premises" && edition == "Standard") {
    if (getAnswer("How is the database queried?").split("'")[1] == "Directly to SQL") {
      numberOfConnections = userAnswers.find(function(obj) {
        return obj.question == "How many connect directly to SQL?";
      });
      numberOfConnections = parseInt(numberOfConnections.customObj.total);
      if (numberOfConnections >= 25) {
        if (getAnswer("Is your SQL instance deployed on Host or VM?").split("'")[1] == "Host") {
          numCores = getAnswer("How many physical cores does your host have?");
        } else {
          numCores = getAnswer("How many cores does the VM have allocated?");
        }
      }
    } else { // Through an application
      if (!runsPublicApp) {
        numberOfConnections = userAnswers.find(function(obj) {
          return obj.question == "How many connect to the application?";
        });
        numberOfConnections = parseInt(numberOfConnections.customObj.total);
        if (numberOfConnections >= 25) {
          if (getAnswer("Is your SQL instance deployed on Host or VM?").split("'")[1] == "Host") {
            numCores = getAnswer("How many physical cores does your host have?");
          } else {
            numCores = getAnswer("How many cores does the VM have allocated?");
          }
        }
      } else {
        if (getAnswer("Is your SQL instance deployed on Host or VM?").split("'")[1] == "Host") {
          numCores = getAnswer("How many physical cores does your host have?");
        } else {
          numCores = getAnswer("How many cores does the VM have allocated?");
        }
      }
    }
    if (
      (numberOfConnections >= 25 && numberOfConnections <= 37 && numCores <= 6) ||
      (numberOfConnections >= 38 && numberOfConnections <= 50 && numCores <= 8) ||
      (numberOfConnections >= 51 && numberOfConnections <= 63 && numCores <= 10) ||
      (numberOfConnections >= 64 && numberOfConnections <= 76 && numCores <= 12) ||
      (numberOfConnections >= 77 && numberOfConnections <= 89 && numCores <= 14) ||
      (numberOfConnections >= 90 && numberOfConnections <= 102 && numCores <= 16) ||
      (numberOfConnections >= 103 && numberOfConnections <= 115 && numCores <= 18) ||
      (numberOfConnections >= 116 && numberOfConnections <= 128 && numCores <= 20) ||
      (numberOfConnections >= 129 && numberOfConnections <= 141 && numCores <= 22) ||
      (numberOfConnections >= 142)
    ) {
      let calModel = "Microsoft SQL Server " + year + " " + edition + " - License";
      let coreModel = "Microsoft SQL Server " + year + (numCores > 24 ? " Enterprise " : " Standard ") + "- 2 Core License";
      licenseArray.push(
        {
          type: "serverPlusCAL",
          name: calModel,
          total: "1"
        },{
          type: "core",
          name: coreModel,
          total: numCores/2
        }
      );
      recommendedModel = "Both";
      appendToFormData('Recommended licensing model:\r\nBoth\r\n\r\nServer+CAL model licensing:\r\n');
      appendToFormData('1 x ' + calModel + '\r\n');
      var calLicensingRow = getCalLicensingTableRow();
      appendToFormData('\r\nCore model licensing:\r\n' + numCores/2 + ' x ' + coreModel + '\r\n');
    } else if (runsPublicApp) {
      let coreModel = "Microsoft SQL Server " + year + " " + (numCores > 24 ? " Enterprise " : " Standard ") + " - 2 Core License";  
      licenseArray.push(
        {
          type: "core",
          name: coreModel,
          total: numCores/2
        }
      );
      recommendedModel = "Core";
      appendToFormData('Recommended licensing model:\r\nCore Model\r\n\r\n');
      appendToFormData('Core model licensing:\r\n' + numCores/2 + ' x ' + coreModel + '\r\n');
    } else {
      let calModel = "Microsoft SQL Server " + year + " " + edition + " - License";
      licenseArray.push(
        {
          type: "serverPlusCAL",
          name: calModel,
          total: "1"
        }
      );
      recommendedModel = "Server+CAL";
      appendToFormData('Recommended licensing model:\r\nServer+CAL Model\r\n\r\nServer+CAL model licensing:\r\n');
      appendToFormData('1 x ' + calModel + '\r\n');
      var calLicensingRow = getCalLicensingTableRow();
    }
  } else if (environment == "On-Premises" && edition == "Enterprise") {
    
    if (getAnswer("Is your SQL instance deployed on Host or VM?").split("'")[1] == "Host") {
      numCores = getAnswer("How many physical cores does your host have?");
    } else {
      numCores = getAnswer("How many cores does the VM have allocated?");
    }
    let coreModel = "Microsoft SQL Server " + year + " " + edition + " - 2 Core License";  
    licenseArray.push(
      {
        type: "core",
        name: coreModel,
        total: numCores/2
      }
    );
    recommendedModel = "Core";
    appendToFormData('Recommended licensing model:\r\nCore Model\r\n\r\n');
    appendToFormData('Core model licensing:\r\n' + numCores/2 + ' x ' + coreModel + '\r\n');
  } else if (environment == "Cloud" && edition == "Standard") {
    if (getAnswer("How is the database queried?").split("'")[1] == "Directly to SQL") {
      numberOfConnections = userAnswers.find(function(obj) {
        return obj.question == "How many connect directly to SQL?";
      });
      numberOfConnections = parseInt(numberOfConnections.customObj.total);
      if (numberOfConnections >= 25) {
        if (getAnswer("Is your SQL instance deployed on Host or VM?").split("'")[1] == "Host") {
          numCores = getAnswer("How many physical cores does your host have?");
        } else {
          numCores = getAnswer("How many cores does the VM have allocated?");
        }
      }
    } else {
      if (!runsPublicApp) {
        numberOfConnections = userAnswers.find(function(obj) {
          return obj.question == "How many connect to the application?";
        });
        numberOfConnections = parseInt(numberOfConnections.customObj.total);
        if (numberOfConnections >= 25) {
          if (getAnswer("Is your SQL instance deployed on Host or VM?").split("'")[1] == "Host") {
            numCores = getAnswer("How many physical cores does your host have?");
          } else {
            numCores = getAnswer("How many cores does the VM have allocated?");
          }
        }
      } else {
        if (getAnswer("Is your SQL instance deployed on Host or VM?").split("'")[1] == "Host") {
          numCores = getAnswer("How many physical cores does your host have?");
        } else {
          numCores = getAnswer("How many cores does the VM have allocated?");
        }
      }
    }
    if (
      (numberOfConnections >= 25 && numberOfConnections <= 37 && numCores <= 6) ||
      (numberOfConnections >= 38 && numberOfConnections <= 50 && numCores <= 8) ||
      (numberOfConnections >= 51 && numberOfConnections <= 63 && numCores <= 10) ||
      (numberOfConnections >= 64 && numberOfConnections <= 76 && numCores <= 12) ||
      (numberOfConnections >= 77 && numberOfConnections <= 89 && numCores <= 14) ||
      (numberOfConnections >= 90 && numberOfConnections <= 102 && numCores <= 16) ||
      (numberOfConnections >= 103 && numberOfConnections <= 115 && numCores <= 18) ||
      (numberOfConnections >= 116 && numberOfConnections <= 128 && numCores <= 20) ||
      (numberOfConnections >= 129 && numberOfConnections <= 141 && numCores <= 22) ||
      (numberOfConnections >= 142)
    ) {
      let calModel = "Microsoft SQL Server " + year + " " + edition + " - License (w/ Software Assurance)";
      let coreModel = "Microsoft SQL Server " + year + (numCores > 24 ? " Enterprise " : " Standard ") + " - 2 Core License (w/ Software Assurance)";
      licenseArray.push(
        {
          type: "serverPlusCAL",
          name: calModel,
          total: "1"
        },{
          type: "core",
          name: coreModel,
          total: numCores/2
        }
      );
      recommendedModel = "Both";
      ovl = true;
      appendToFormData('Recommended licensing model:\r\nBoth\r\n\r\nServer+CAL model licensing:\r\n');
      appendToFormData('1 x ' + calModel + '\r\n');
      var calLicensingRow = getCalLicensingTableRow();
      appendToFormData('\r\nCore model licensing:\r\n' + numCores/2 + ' x ' + coreModel + '\r\n');

    } else if (runsPublicApp) {
      numCores > 24
      let coreModel = "Microsoft SQL Server " + year + " " + (numCores > 24 ? " Enterprise " : " Standard ") + " - 2 Core License (w/ Software Assurance)";  
      licenseArray.push(
        {
          type: "core",
          name: coreModel,
          total: numCores/2
        }
      );
      recommendedModel = "Core";
      appendToFormData('Recommended licensing model:\r\nCore Model\r\n\r\n');
      appendToFormData('Core model licensing:\r\n' + numCores/2 + ' x ' + coreModel + '\r\n');
    } else {
      let calModel = "Microsoft SQL Server " + year + " " + edition + " - License (w/ Software Assurance)";
      licenseArray.push(
        {
          type: "serverPlusCAL",
          name: calModel,
          total: "1"
        }
      );
      recommendedModel = "Server+CAL";
      ovl = true;
      appendToFormData('Recommended licensing model:\r\nServer+CAL Model\r\n\r\nServer+CAL model licensing:\r\n');
      appendToFormData('1 x ' + calModel + '\r\n');
      var calLicensingRow = getCalLicensingTableRow();
    }
  } else if (environment == "Cloud" && edition == "Enterprise") {
    numCores = getAnswer("How many cores does the VM have allocated?");
    let coreModel = "Microsoft SQL Server " + year + " " + edition + " - 2 Core License (w/ Software Assurance)";
    licenseArray.push(
      {
        type: "core",
        name: coreModel,
        total: numCores/2
      }
    );
    recommendedModel = "Core";
    ovl = true;
    appendToFormData('Recommended licensing model:\r\nCore Model\r\n\r\n');
    appendToFormData('Core model licensing:\r\n' + numCores/2 + ' x ' + coreModel + '\r\n');
  }
  licenseArray.forEach((license) => {
    if (license.type == "serverPlusCAL") {
      serverTableResults += '<tr class="results-table-row"><td class="text-start">' + license.name + '</td><td class="text-center">' + license.total + '</td></tr>';
    } else if (license.type == "core") {
      coreTableResults += '<tr class="results-table-row"><td class="text-start">' + license.name + '</td><td class="text-center">' + license.total + '</td></tr>';
    }
  });

  var calCount = getCalCount();

  if (recommendedModel != "Both") {
    let licensingModelBodyText = "To best suit your environment, we highly recommend the <strong class='highlight-text'>" + recommendedModel + " model</strong>, which offers significant cost savings. Take the next step by <strong>requesting a personalized quote</strong>. Our team will assess your environment thoroughly to determine if you qualify for additional savings.";
    let whatYouNeedBodyText = "Here's what you'll need to fully license your SQL Server environment through the <strong class='highlight-text'>" + recommendedModel + " model</strong>. ";
    if ((runsPublicApp && edition == "Standard" && numCores > 24)) {
      whatYouNeedBodyText += "Although you selected Standard, Enterprise edition is required for your environment because Standard can only license a max of 24 cores.";
    }
    let recommendedTag = '<span class="position-absolute" style="box-shadow: 0px 2px 5px 0px var(--box-shadow); padding: 5px 10px; font-size: var(--font-size-xxs); border-radius: 3px; background: gold; color: black; top: -20px; left: 50%; transform: translateX(-50%); width: max-content;"><i class="fa-solid fa-thumbs-up me-2"></i> Our recommendation</span>';
    document.querySelector('#licensing-models-body').innerHTML = licensingModelBodyText;
    if (recommendedModel == "Server+CAL") {
      document.querySelector("#server-cal-box").classList.remove("standard-box");
      document.querySelector("#server-cal-box").classList.add("recommended-box", "recommended-option");
      document.querySelector("#server-cal-box").insertAdjacentHTML('afterbegin',recommendedTag)
      document.querySelector("#serverPlusCalTableResults").classList.add("recommended-option");
      document.querySelector("#serverPlusCalTableResults").style.display = "block";
      calCount > 4 && (document.querySelector('#cal-recommend-bundle').style.display = 'flex');
    } else if (recommendedModel == "Core") {
      document.querySelector("#core-box").classList.remove("standard-box");
      document.querySelector("#core-box").classList.add("recommended-box", "recommended-option", "mt-5", "mt-xxl-0");
      document.querySelector("#core-box").insertAdjacentHTML('afterbegin',recommendedTag)
      document.querySelector("#coreTableResults").classList.add("recommended-option");
      document.querySelector("#coreTableResults").style.display = "block";
    }
    document.querySelector("#what-you-need-body").innerHTML = whatYouNeedBodyText;
  } else if (recommendedModel == "Both") {
    let licensingModelBodyText = "For your environment, either licensing model would be suitable. However, if you have plans to expand your business, we highly recommend <a class='highlight-link' href onclick='scheduleSqlCalc()'>scheduling a call</a> with one of our licensing experts. Their expertise will help you determine the ideal model that aligns with your growth goals and specific requirements. ";
    document.querySelector('#licensing-models-body').innerHTML = licensingModelBodyText;
    var whatYouNeedBodyText = "Your choice between the options will determine the specific licensing requirements based on your responses. Here's what you'll need to license under each option. If you're unsure which one to choose, consider <a class='highlight-link' href onclick='scheduleSqlCalc()'>scheduling a call</a> with one of our licensing experts for guidance.";
    if (edition == "Standard" && numberOfConnections >=142 && numCores > 24) {
      $("#core-model-disclaimer").show();
    }
    document.querySelector("#what-you-need-body").innerHTML = whatYouNeedBodyText;
    document.querySelector("#serverPlusCalTableResults").style.display = "block";
    document.querySelector("#coreTableResults").style.display = "block";
    calCount > 4 && (document.querySelector('#cal-recommend-bundle').style.display = 'flex');
  }
  document.querySelector('#sql-table-header').innerHTML = '<th style="text-align: left; width: 75%;">Recommended License</th><th class="text-center"># of Licenses</th>';
  document.querySelector("#sql-table-results").innerHTML = serverTableResults + calLicensingRow;
  document.querySelector("#core-table-results").innerHTML = coreTableResults;
}

  
// Set CAL licensing info to be displayed on the results page
function getCalLicensingTableRow() {
  var calLicensingTableHTML = '';
  var calYear = getAnswer("What version year do you need?").split("'")[1];
  var calEnvironment = getAnswer("Is this for an On-Premises or Cloud Environment?").split("'")[1];
  var calTableVisible = true;
  
  if (getAnswer("How is the database queried?").split("'")[1] == "Directly to SQL") {
    var cal = userAnswers.find(function(obj) {
      return obj.question == "How many connect directly to SQL?";
    });
  } else if (getAnswer("How is the database queried?").split("'")[1] == "Through an application") {
    if (getAnswer("Are you running a public web-facing application?").split("'")[1] == "No") {
      var cal = userAnswers.find(function(obj) {
        return obj.question == "How many connect to the application?";
      });
    } else {
      calTableVisible = false;
    }
  } else {
    calTableVisible = false;
  }
  if (calTableVisible){
    if (cal.customObj.type) {
      var calType = cal.customObj.type.charAt(0).toUpperCase() + cal.customObj.type.slice(1);
    }
    var calCount = cal.customObj.total;      
    calLicensingTableHTML += '<tr><td class="color-highlight">Microsoft SQL Server ' + calYear + ' - 1 ' + calType + ' CAL' + (calEnvironment == "Cloud" ? ' (w/ Software Assurance)' : '')  + '</td><td class="text-center">' + calCount + '</td></tr>';
  }

  calTableVisible ? appendToFormData(calCount + ' x Microsoft SQL Server ' + calYear + ' - 1 ' + calType + ' CAL' + (calEnvironment == "Cloud" ? ' (w/ Software Assurance)' : '') + '\r\n') : {};
  return calLicensingTableHTML;
}

// Returns the amount of connections required based on the user's responses
function getCalCount() {
  var calIsVisible = true;
  if (getAnswer("How is the database queried?").split("'")[1] == "Directly to SQL") {
    var cal = userAnswers.find(function(obj) {
      return obj.question == "How many connect directly to SQL?";
    });
  } else if (getAnswer("How is the database queried?").split("'")[1] == "Through an application") {
    var cal = userAnswers.find(function(obj) {
      return obj.question == "How many connect to the application?";
    });
  } else {
    calIsVisible = false;
  }
  if (calIsVisible){
    var calCount = cal.customObj.total;
  } else {
    var calCount = 0;
  }
  return calCount;
}
  
// Sets the user's answers to be sent if 'Request a Quote' form submitted
function addResponsesToRFQ() {
  calcResults += '\r\nResponses:\r\n';
  userAnswers.forEach((question) => {
    if(question.answer){
      if(question.answer != ''){
        calcResults += question.question + '\r\n';
        var displayedAnswer;
        if (question.answer.includes("'")){
          displayedAnswer = question.answer.split("'")[1];
        } else {
          displayedAnswer = question.answer;
        }
        calcResults += displayedAnswer + '\r\n\r\n';
      }
    }
    if(question.customObj){
      if(question.customObj != ''){
        calcResults += question.question + '\r\n';
        var displayedAnswer;
        displayedAnswer = question.customObj.total + ' ' + question.customObj.type + '(s)';
        calcResults += displayedAnswer + '\r\n\r\n';
      }
    }
  });
}
  
// Generate link to pre-filled Calendly form based on data from calculator, pass in response and question if generating link while user is on a question
function setPrefilledCalendlyFormLink(response, question) {
  calendlySqlLink = 'https://calendly.com/trusted-tech-team-licensing-engineer/sql';
  var calendlyParams = '';

  // Prefill with current question if help requested
  if (response == 'help') {
    calendlyParams += "Hi Trusted Tech Team,%0A%0AI need help answering this question on the SQL Server Calculator:%0A" + question + "%0A%0A";
  } else if (response == "calc-error") {
    calendlyParams += "Hi Trusted Tech Team,%0A%0AI need SQL Server, but I have a complex environment. Can you please evaluate it?%0A%0A"
  }

  var currentQuestion = document.getElementById('sql-question-text').innerHTML;

  if (currentQuestion != 'Is this for an On-Premises or Cloud Environment?') {
    calendlyParams += 'Here are my SQL Server calculator responses:%0A%0A';
    userAnswers.forEach((question) => {
      if(question.answer){
        if(question.answer != ''){
          calendlyParams += 'Q: ' + question.question + '%0A';
          var displayedAnswer;
          if (question.answer.includes("'")){
            displayedAnswer = 'A: ' + question.answer.split("'")[1];
          } else {
            displayedAnswer = 'A: ' + question.answer;
          }
          calendlyParams += displayedAnswer + '%0A%0A';
        }
      }
      if(question.customObj){
        if(question.customObj != ''){
          calendlyParams += 'Q: ' + question.question + '%0A';
          var displayedAnswer;
          displayedAnswer = 'A: ' + question.customObj.total + ' ' + question.customObj.type + '(s)';
          calendlyParams += displayedAnswer + '%0A%0A';
        }
      }
    });
  }

  calendlySqlLink += '?a2=' + calendlyParams;
}
  
// Triggered when user reaches the last question in a pathway
function showResults(action) {
  $("#sql-questions").addClass("hidden");
  window.scroll(0,0);

  displayLoadingIcon();

  setTimeout(() => {
    $('#loading-screen').hide();
    if (action == "calc-error") {
      setCalendlyOnClick("calc-error")
      $("#sql-no-results").removeClass("hidden"); 
    } else if (userAnswers[3].answer == "'One'"){
      $("#sql-results").removeClass("hidden");
    } else {
      setCalendlyOnClick("calc-error")
      $("#sql-no-results").removeClass("hidden"); 
    }
  }, 1000);

  setResponses();
  calculateLicensing();
  addResponsesToRFQ();
  
  // pageHandle variable pulled from sql-server-calculator.liquid
  $('#request-a-quote-form').html('<iframe frameborder="0" id="rfq-iframe" style="height:620px;width:99%;border:none;color-scheme:light;" src="https://forms.zohopublic.com/trustedtechteam/form/RequestforQuote1/formperma/LpJaE8Ghb9imMZgoQhQv3vmnNGII0hF_2zsqIlCSeeY?MultiLine=' + encodeURIComponent(calcResults) + '&PageHandle=' + pageHandle + '"></iframe>');

  setPrefilledCalendlyFormLink(); 
}
  
// Adds to the 'Request a Quote' form data.
function appendToFormData(data) {
  calcResults += data;
}

// Shows the first question in the calculator. Triggered when user clicks 'Start' on landing page.
function beginCalculator() {
  $("#main-questions-container").addClass("hidden");
  $("#sql-questions").removeClass("hidden");
  window.scroll(0,0);
}

// Resets content and goes back to 1st question . Triggered when user clicks any 'Restart Calculator' button
function restartSqlCalc() {

  // Reset global variables
  previousQuestionPath = [];
  calendlySqlLink = 'https://calendly.com/trusted-tech-team-licensing-engineer/sql';
  calcResults = 'Hi Trusted Tech Team,\r\n\r\nCould you please send me a personalized quote based on my SQL Server Calculator results?\r\n\r\nThank you!\r\n\r\nMy SQL Server Calculator Results:\r\n\r\n';

  // Reset all answers
  userAnswers.forEach(function(question) {
    if (question.answer) {
      question.answer = '';
    } else if (question.customObj) {
      question.customObj = '';
    }
  });

  // Hide results page, reset results page content, show first question
  $('#sql-results').addClass("hidden");
  $('#licensing-models-container').html('<h2 class="text-start">Licensing models</h2><p class="text-start" id="licensing-models-body">For you environment, either licensing model would work for you. Although, if you do plan on growing your business, we recommend speaking with one of our licensing experts to help further determine which model would be best for you.</p><div class="row gap-3 gap-xxl-0 mt-5"><div class="col-xxl-6"><div class="text-start p-4 option-box standard-box position-relative" id="server-cal-box"><p class="option-tag">Option #1</p><p class="fw-bold option-title">Server+CAL Model</p><p>Provides the option to license users and/or devices, with low-cost access to incremental SQL Server deployments.</p><div id="header-icons" class="d-flex flex-wrap"><div class="d-flex align-items-center"><i class="fa-solid fa-check"></i> Standard edition available</div><div class="d-flex align-items-center"><i class="fa-solid fa-xmark"></i> Enterprise edition available</div></div></div></div><div class="col-xxl-6"><div class="text-start p-4 option-box standard-box position-relative" id="core-box"><p class="option-tag">Option #2</p><p class="fw-bold option-title">Core Model</p><p>Gives a more precise measurement of computing power and a more consistent metric.</p><div id="header-icons" class="d-flex flex-wrap"><div class="d-flex align-items-center"><i class="fa-solid fa-check"></i> Standard edition available</div><div class="d-flex align-items-center"><i class="fa-solid fa-check"></i> Enterprise edition available</div></div></div></div></div>');
  $('#cal-licensing-container').html("<h2>What you'll need</h2><p id='what-you-need-body'></p><div class='licensing-table hide-initial-load' id='serverPlusCalTableResults'><p class='option-tag'>Option #1</p><p class='fw-bold table-title'>Server+CAL model licensing</p><div id='cal-recommend-bundle' class='mb-2 align-items-center icon-row hide-initial-load'><i class='fa-solid fa-flag'></i><div class='text-start lh-base'>Potential Opportunity for Bundling - <strong>Request a Quote</strong> or <a class='cta-links' onclick='scheduleSqlCalc()'>Call</a></div></div><div id='server-licensing-table'><table><thead><tr id='sql-table-header'></tr></thead><tbody id='sql-table-results'></tbody></table></div></div><div class='licensing-table hide-initial-load' id='coreTableResults'><p class='option-tag'>Option #2</p><p class='fw-bold table-title'>Core model licensing</p><div id='core-model-disclaimer' class='mb-2 align-items-center icon-row hide-initial-load'><p class='m-0'><i class='fa-solid fa-flag'></i>Standard edition can only license a maximum of 24 cores</p></div><div id='server-licensing-table'><table><thead><tr id='sql-table-header'><th class='text-start w-75'>Recommended License</th><th class='text-center'># of Licenses</th></tr></thead><tbody id='core-table-results'></tbody></table></div></div>");
  $('#sql-question-text').html('Is this for an On-Premises or Cloud Environment?');
  $('#sql-question-answers').html('<div class="d-flex flex-wrap gap-3 justify-content-start justify-content-lg-center"><button class="raise collection-button calc-button m-0 text-start" onclick="showNextQuestion(this.textContent, this)"><i class="fa-regular fa-circle regular"></i><i class="fa-solid fa-circle solid" style="display: none;"></i>On-Premises</button><button class="raise collection-button calc-button m-0 text-start" onclick="showNextQuestion(this.textContent)"><i class="fa-regular fa-circle regular"></i><i class="fa-solid fa-circle solid" style="display: none;"></i>Cloud</button></div>');
  $('#percent-complete').html(' 0% COMPLETE');
  $('#input-requirements').html('');
  $('#progress-container').html('<div class="progress-bar" role="progressbar" aria-valuenow="10" aria-valuemin="0" aria-valuemax="100"><span class="sr-only">0% Complete</span></div>');
  $('.btn-previous').hide();
  $("#sql-no-results").addClass("hidden"); 
  $("#sql-questions").removeClass("hidden");
  window.scroll(0,0);
}

// Initialize the tooltips if applicable
function setTooltips() {
  $(function() {
    tippy('[data-tippy-content]');
  });
}

// Sets the onclick function for any Calendly button on a question to include the current question and all previous answers
function setCalendlyOnClick(response, question) {
  if (response == 'help') {
    setPrefilledCalendlyFormLink(response, question);
    var sqlQuestions = document.getElementById('calendly-button-container');
    var calendlyButton = sqlQuestions.querySelector('.button-calendly');
  } else if (response == "calc-error") {
    setPrefilledCalendlyFormLink(response);
    var sqlQuestions = document.getElementById('sql-no-results');
    var calendlyButton = sqlQuestions.querySelector('.button-calendly');
  }

  calendlyButton.setAttribute('onclick','scheduleSqlCalc()');

  var calendlyFixedButton = document.querySelector('.btn-fixed-calendly');
  if (calendlyFixedButton) {
    calendlyFixedButton.setAttribute('onclick','scheduleSqlCalc()');
  }
}

// Display Calendly pop-up form
function scheduleSqlCalc() {
  Calendly.showPopupWidget(calendlySqlLink);
  return false;
}
